import { Grid } from "@mui/material";
import React, { useState, useCallback, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { callAPI, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../StateManagement/actions";
import WSButton from "../../Components/Button/WSButton";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import { BarChart, CreditCard, Description, LocalActivity, Person, Today, TrendingUp } from '@mui/icons-material';
import StatsCard, { StatsCardProps } from "../Home/subComponents/StatsCard";


export const PurchaseList: React.FC<any> = React.memo(() => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("All Records");
  const selectedIdRef = useRef<string>("");

  const [stats, setStats] = useState({
    totalPurchase: {} as StatsCardProps,
    totalPurchaseInvoices: {} as StatsCardProps,
    monthlyPurchase: {} as StatsCardProps,
    todayPurchase: {} as StatsCardProps,
  });


  const filters = ["All Records"];

  useEffect(() => {
    updateMainHeader("Purchase List");
    breadCrumbsStore.updateBreadCrumbs([{ "Purchase List": "/purchase/list" }]);
  }, []);

  const source = {
    url: "Vyapar/Purchase/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };


  async function getData() {
    try {
      setLoading(true)
      const response: any = await callAPI(`Vyapar/Purchase/purchase-dashboard`, Method.GET);

      console.log('dashboard ata', response);

      if (response) {
        setStats({
          totalPurchase: response.totalPurchase,
          todayPurchase: response.todayPurchase,
          monthlyPurchase: response.monthlyPurchase,
          totalPurchaseInvoices: response.totalPurchaseInvoices
        });
      }
    } catch (error) {
      console.error("failed to retrieve data", error);
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    updateMainHeader('Sale Invoice');
    if (id) {

    } else {
      getData();
    }
  }, [id]);


  const handleAction = useCallback(async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/purchase/edit/${row.id}`);
    } else if (action === "Delete") {
      selectedIdRef.current = row.id;
      setPopupOpen(true);
    }
  }, [navigate]);

  const columns: IColumns[] = [
    { header: "Bill No", fieldName: "billNo", },
    { header: "Vendor Name", fieldName: "partyName", },
    { header: "Phone", fieldName: "phoneNumber", },
    { header: "Bill Date", fieldName: "billDate", type: "date", },
    { header: "Total Amount", fieldName: "total", },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: handleAction
    },
  ];

  const handleClick = useCallback(() => {
    navigate("/purchase");
  }, [navigate]);

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <StatsCard
          title="Total Purchase Amount"
          value={stats.totalPurchase.value}
          trend={stats.totalPurchase.trend}
          label={stats.totalPurchase.label}
          subtitle={stats.totalPurchase.subtitle}
          icon={<TrendingUp sx={{ fontSize: 28 }} />}
          color={stats.totalPurchase.color}
          loading={loading}
          format="currency"
        />

        <StatsCard
          title="Today Purchase Amount"
          value={stats.todayPurchase.value}
          trend={stats.todayPurchase.trend}
          label={stats.todayPurchase.label}
          subtitle={stats.todayPurchase.subtitle}
          icon={<Today sx={{ fontSize: 28 }} />}
          color={stats.todayPurchase.color}
          loading={loading}
          format="currency"
        />

        <StatsCard
          title="Total Purchase Invoice"
          value={stats.totalPurchaseInvoices.value}
          trend={stats.totalPurchaseInvoices.trend}
          label={stats.totalPurchaseInvoices.label}
          subtitle={stats.totalPurchaseInvoices.subtitle}
          icon={<Description />}
          color={stats.totalPurchaseInvoices.color}
          loading={loading}
        />

        <StatsCard
          title="Month Purchase"
          value={stats.monthlyPurchase.value}
          trend={stats.monthlyPurchase.trend}
          label={stats.monthlyPurchase.label}
          subtitle={stats.monthlyPurchase.subtitle}
          icon={<BarChart sx={{ fontSize: 28 }} />}
          color={stats.monthlyPurchase
            .color}
          loading={loading}
          format="currency"
        />
        <Grid item xs={12}>
          <WSDataGrid
            id="purchaseGrid"
            title="Purchase List"
            columns={columns}
            source={source}
            searchBox={{ fieldName: 'billNo' }}
            addButton={{ label: "Add New Purchase", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
        <ConfirmationPopup
          type="DELETE"
          apiUrl="Vyapar/Purchase"
          id={selectedIdRef.current}
          confirmMessage="Are you sure you want to delete this purchase?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("purchaseGrid"));
            getData();
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.message, "error");
            }
          }}
        />
      </Grid>
    </Grid>
  );
});

export default PurchaseList;
